import { render, staticRenderFns } from "./edit-customer.vue?vue&type=template&id=4846e5d9&scoped=true"
import script from "./edit-customer.vue?vue&type=script&lang=js"
export * from "./edit-customer.vue?vue&type=script&lang=js"
import style0 from "./edit-customer.vue?vue&type=style&index=0&id=4846e5d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846e5d9",
  null
  
)

export default component.exports